// Muted, looping video background for hero title areas.
export default function HeroVideoBg({ src, poster, className = "" }) {
  return (
    <video
      className={`h-full w-full object-cover ${className}`}
      autoPlay
      muted
      loop
      playsInline
      preload="metadata"
      poster={poster}
      data-testid="hero-video"
    >
      <source src={src} type="video/mp4" />
    </video>
  );
}
